<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+courseId" :props="props" :map="map" :bus="bus"
            edit-button="1" :title2="programTitle"
            button-icon="edit" :button-name="lang.polaris.form.edit" :button-handler="edit" 
        ></trax-ui-top-box>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id" :bus="bus">
            <trax-training-course-edit-form :bus="bus" :id="id" :toastr-id="id+'-toastr'" :endpoint="endpoint">
            </trax-training-course-edit-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-training-course-edit-top-box'},
            programTitle: null,
            courseId: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/phases',
                props: {
                    name: { source:'data.name' },
                    description: {source: 'data.description'},
                    background: {source: 'data.background'}
                },
                map: {
                    title1: 'name',
                    description: 'description',
                    backgroundImage: 'background'
                },
                bus: new Vue()
            }
        },

        methods: {

            edit: function(data) {
                this.bus.$emit(this.id+'-update', data);
            }
        }

    }
</script>
